export default __webpack_public_path__ + "static/media/element_18.e73793e5.webp";